module.exports = __webpack_public_path__ + "static/media/batg.89ed57c7.jpg";